import { apiClient } from '../../../Utilities/apiClient';

export interface JtaRegion {
  id: number;
  name: string;
  sortOrder: number;
}

export interface CreateJtaRegionRequest {
  name: string;
  sortOrder?: number;
}

export interface UpdateJtaRegionRequest {
  name?: string;
  sortOrder?: number;
}

export interface JtaStat {
  value: string;
  label: string;
}

export interface JtaContent {
  id: number;
  identityLabel: string;
  title: string;
  aboutTitle: string;
  aboutBody: string;
  stats: JtaStat[];
  orgTitle: string;
  orgBody: string;
  websiteUrl: string;
  instagramUrl: string;
  ctaLabel: string;
}

export type UpdateJtaContentRequest = Partial<Omit<JtaContent, 'id'>>;

export const jtaService = {
  // Region operations
  getRegions: async (): Promise<{ data: { regions: JtaRegion[] } }> => {
    return apiClient.get('/jta/regions');
  },

  createRegion: async (region: CreateJtaRegionRequest): Promise<{ data: { region: JtaRegion } }> => {
    return apiClient.post('/jta/regions', region);
  },

  updateRegion: async (id: number, region: UpdateJtaRegionRequest): Promise<{ data: { region: JtaRegion } }> => {
    return apiClient.put(`/jta/regions/${id}`, region);
  },

  deleteRegion: async (id: number): Promise<{ data: unknown }> => {
    return apiClient.delete(`/jta/regions/${id}`);
  },

  // Landing content (singleton)
  getContent: async (): Promise<{ data: { content: JtaContent } }> => {
    return apiClient.get('/jta/content');
  },

  updateContent: async (content: UpdateJtaContentRequest): Promise<{ data: { content: JtaContent } }> => {
    return apiClient.put('/jta/content', content);
  },
};

export default jtaService;
